<template>
  <div id="rose-chart">
    <div class="rose-chart-title">人员类型分布</div>
    <!-- <dv-charts :option="option" style="height: 600px; width: 600px" /> -->
    <div id="rangepie2" style="width: 100%; height: 600px"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
export default {
  props: {
    value: Object,
    config: Object
  },

  data() {
    return {}
  },

  methods: {
    myEcharts(data) {
      // 基于准备好的dom，初始化echarts实例

      var myChart = echarts.init(document.getElementById('rangepie2'))
      var option
      if (data.length === 0) {
        option = {
          title: {
            text: '暂无数据',
            x: 'center',
            y: 'center',
            textStyle: {
              fontSize: 14,
              fontWeight: 'normal',
              color: '#fff'
            }
          }
        }
      } else {
        let colors = ['#f86464', '#fa8f3d', '#8c70f8', '#19dc7c', '#34a6fe', '#e8ea3e']
        if (this.config.Colors && this.config.Colors.length) {
          colors = data.map((item) => {
            return item.color
          })
        }
        option = {
          backgroundColor: '#0a1e3d',
          title: {
            subtext: this.config.SubTitle || '',
            left: 'center'
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          color: colors,

          legend: {
            orient: 'vertical',
            left: 4,
            top: 10,
            data: data.map((c) => {
              return c.name
            }),

            textStyle: {
              //图例文字的样式
              color: '#fff',
              fontSize: 16
            }
          },
          series: [
            {
              name: this.config.FieldTitle || '数据',
              type: 'pie',
              data: data,
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    fontSize: 18
                  }
                },
                emphasis: {
                  show: true
                }
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
                label: {
                  show: false,
                  fontSize: 16,
                  fontWeight: 'bold'
                }
              }
            }
          ]
        }
      }
      myChart.on('click', (params) => {
        this.dialogTableVisible = true
        this.ScoreList = params.data.list
      })
      myChart.setOption(option)
    },

    LoadData() {
      this.$matrix.AjaxGet3('Users', 'GetList', { Page: 1, PageSize: 0, GetCount: true, GetCategory: true, Fields: ['IdCount'], Groups: ['Category'] }, this.config.Role, this.config.RoleField).then((data) => {
        if (data.Items.length) {
          let res = data.Items.map((item) => {
            return {
              name: item.Category.Name,
              value: item.IdCount
            }
          })
          this.myEcharts(res)
        }
      })
    }
  },
  mounted() {
    this.LoadData()
  }
}
</script>

<style scoped>
#rose-chart {
  width: 100%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, 0.5);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

#rose-chart .rose-chart-title {
  height: 50px;
  font-weight: 700;
  text-indent: 20px;
  font-size: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

#rose-chart .dv-charts-container {
  height: calc(100% - 50px);
}
</style>